// extracted by mini-css-extract-plugin
module.exports = {"container":"Background_container__fCrs7","gradientBackground":"Background_gradientBackground__PeiR2"};